import type { RenovacaoFlag } from '@/constants/planosCNPJ';
import type { RenovacaoFaixaParametro } from '@/hooks/useRenovacaoParametros';

export { normalizarMsisdn } from '../../../backend/src/services/propostas/normalizar-msisdn';

export function tabelaDaRenovacao(flags: RenovacaoFlag[]): '1' | '2' | 'INDETERMINADO' {
  if (flags.includes('NAO_INFORMADO')) return 'INDETERMINADO';
  return flags.includes('SIM') ? '1' : '2';
}

export function deltasDaRenovacao(ticketAtual: number, receitaRenovada: number) {
  if (!Number.isFinite(ticketAtual) || ticketAtual <= 0) return { economico: null, literal: null };
  const economico = Number((((receitaRenovada - ticketAtual) / ticketAtual) * 100).toFixed(2));
  return { economico, literal: Number((-economico).toFixed(2)) };
}

export function faixaDoDelta(delta: number | null, faixas: RenovacaoFaixaParametro[]) {
  if (delta === null) return null;
  return faixas.find((item) =>
    item.tabela === 1
    && (item.delta_min === null || delta >= Number(item.delta_min))
    && (item.delta_max === null || delta <= Number(item.delta_max)),
  )?.faixa ?? null;
}

export function fatorDoCluster(
  faixa: RenovacaoFaixaParametro | undefined,
  cluster: 'P' | 'M' | 'G' | 'NAO_INFORMADO',
) {
  if (!faixa || cluster === 'NAO_INFORMADO') return null;
  if (cluster === 'P') return Number(faixa.fator_p);
  if (cluster === 'M') return Number(faixa.fator_m);
  return Number(faixa.fator_g);
}
